import React from 'react';

import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import TabComissions from '../../components/TabComissions';
import TabListings from '../../components/TabListings';
import { createPartnerConfig } from '../base/PartnerConfigFactory';

import Parameters from './Parameters';
import validate from './validate';

export const name = 'EnergiaReal';

const config = createPartnerConfig({
    ParametersComponent: Parameters,
    algorithms: [],
    buildPayloadConfig: {
        extendPayload: (basePayload, values) => {
            const {
                api_key,
                commision_configs,
                file_rate,
                list_configs_opened,
                list_configs_protected,
                opex,
                opex_active,
                opex_cost_ranges_kw,
                opex_costing_type,
                opex_periodicity,
                percentage_work_funding,
            } = values;

            const extended = {
                ...basePayload,
                commision_configs: JSON.stringify(commision_configs),
                list_configs: JSON.stringify([
                    ...list_configs_opened,
                    ...list_configs_protected,
                ]),
                opex,
                opex_active,
                opex_cost_ranges_kw: JSON.stringify(opex_cost_ranges_kw),
                opex_costing_type,
                opex_periodicity,
                percentage_work_funding,
            };

            // Agregar file_rate si existe
            if (Array.isArray(file_rate) && file_rate.length > 0) {
                extended.file_rate = file_rate[0];
            }

            // Agregar API key si no está vacío
            if (!isEmpty(api_key)) {
                extended.api_key = api_key;
            }

            return extended;
        },
    },
    buildPrepareValuesConfig: {
        extendPrepareValues: (baseValues, values) => {
            const list_configs_opened = Array.isArray(values.list_configs)
                ? values?.list_configs?.filter((item) => item.type === 'opened')
                : [];
            const list_configs_protected = Array.isArray(values.list_configs)
                ? values?.list_configs?.filter(
                      (item) => item.type === 'protected',
                  )
                : [];
            return {
                ...baseValues,
                api_key: values.api_key || '',
                commision_configs: values.commision_configs || [],
                file_rate: values.parameters[0]?.file_rate || null,
                list_configs_opened,
                list_configs_protected,
                opex: values.opex || 0,
                opex_active: values.opex_active || false,
                opex_cost_ranges_kw: values.opex_cost_ranges_kw || [],
                opex_costing_type:
                    values.opex_costing_type || 'by_fixed_amount',
                opex_periodicity: values.opex_periodicity || 1,
                percentage_work_funding: values.percentage_work_funding || 0,
            };
        },
    },
    customAlgorithms: [
        { label: 'Energía Real API', value: 'er_ppa_api' },
        { label: 'Lease API', value: 'lease_api' },
        { label: 'PPA API Key', value: 'ppa_api_key' },
    ],
    name,
    tabsConfig: {
        additionalTabs: ({ control, disabled, getValues, setValue }) => [
            {
                component: (
                    <TabComissions
                        control={control}
                        currencyIso="MXN"
                        currencySymbol="$"
                        disabled={disabled}
                        getValues={getValues}
                        setValue={setValue}
                    />
                ),
                id: 'tab-comissions',
                label: i18next.t('Commissions'),
                value: 'comissions',
            },
            {
                component: (
                    <TabListings
                        control={control}
                        disabled={disabled}
                        getValues={getValues}
                        setValue={setValue}
                    />
                ),
                id: 'tab-listings',
                label: i18next.t('Listings'),
                value: 'listings',
            },
        ],
    },
    validationConfig: { schema: validate },
});

const originalGetInitialValues = config.getInitialValues;
config.getInitialValues = () => ({
    ...originalGetInitialValues(),
    api_key: '',
    commision_configs: [
        {
            auth_emails: [],
            bess_percentage: 5,
            fv_percentage: 1,
            type: 'external',
        },
        {
            auth_emails: [],
            bess_percentage: 0,
            fv_percentage: 0,
            type: 'internal',
        },
    ],
    list_configs_opened: [
        {
            name: 'Rating Cliente',
            key: 'CLIENT_RATING',
            values: ['A1', 'A2', 'A3', 'B1'],
            auth_emails: [],
            type: 'opened',
        },
        {
            name: 'Calendario de Capex',
            key: 'PV_CAPEX_SCHEDULE_SCENARIO',
            values: ['Standar', 'Tier 1', 'Tier 2', 'Tier 3'],
            auth_emails: [],
            type: 'opened',
        },
    ],
    list_configs_protected: [
        {
            name: 'Rating Cliente',
            key: 'CLIENT_RATING',
            values: ['A1', 'A2', 'A3', 'B1'],
            auth_emails: [],
            type: 'protected',
        },
        {
            name: 'Calendario de Capex',
            key: 'PV_CAPEX_SCHEDULE_SCENARIO',
            values: ['Standar', 'Tier 1', 'Tier 2', 'Tier 3'],
            auth_emails: [],
            type: 'protected',
        },
    ],
    opex: 0,
    opex_active: false,
    opex_cost_ranges_kw: [{ amount: 0, max: 10, min: 0 }],
    opex_costing_type: 'by_fixed_amount',
    opex_periodicity: 1,
    percentage_work_funding: 0,
    type_algorithm: 'er_ppa_api',
});

export default { ...config, name };
